uniform float uBigWavesElevation;

uniform float uSmallWavesElevation;

uniform float uFoamBrightness;
uniform float uFoamOffset;

uniform vec3 uDepthColor;
uniform vec3 uSurfaceColor;
uniform float uColorOffset;
uniform float uColorMultiplier;

varying float vElevation;
varying vec2 vUv;
varying float vFoamElevation;

void main()
{
    // color based on the big waves
    float normalizedElevation = vElevation + vFoamElevation + uSmallWavesElevation / 2.0; // inital -0.2 to 0.2
    normalizedElevation += uBigWavesElevation; // shift to 0 to 0.4
    normalizedElevation += uColorOffset; // extra offset
    normalizedElevation *= ( 1.0 / (uBigWavesElevation * 2.0) ); // normalize 0 to 1
    normalizedElevation *= uColorMultiplier; // extra multiplier
    vec3 mixedColor = mix(uDepthColor, uSurfaceColor, normalizedElevation);

    // foam color
    float foamElevation = vFoamElevation;
    foamElevation += uSmallWavesElevation; // normalize
    foamElevation *= uFoamBrightness; // brightness
    foamElevation -= uFoamOffset; // extra offset
    foamElevation = clamp(foamElevation, 0.0, 100.0);
    vec3 foamColor = vec3(foamElevation, foamElevation, foamElevation);
    mixedColor += foamColor;

    // fog
    vec2 cUv = vUv; // declare 0 to 1
    cUv -= 0.5; // center -0.5 to 0.5
    cUv *= 2.0; // normalize
    float circle = length(cUv); // use length from 0 to 1
    circle *= 2.0; // compress from 0 to 2
    circle -= 1.0; // circle radius 0 to 1
    circle = 1.0 - circle; // inverse
    circle = clamp(circle, 0.0, 1.0); // clamp
    vec3 uvColor = vec3(circle,circle,circle);
    mixedColor *= uvColor;

    // moon light
    vec3 moonLight = vec3(cUv.x); // gradient
    moonLight = abs(moonLight); // doublesided
    moonLight *= 15.0;
    moonLight = 1.0 - moonLight;
    moonLight = clamp(moonLight, 0.0, 0.9);
    moonLight *= clamp((vFoamElevation + 0.12) * 5.0, 0.0, 1.0);
    moonLight = clamp(moonLight, 0.0, 0.40);
    mixedColor += moonLight;


    gl_FragColor = vec4(mixedColor, 1.0);
    // #include <colorspace_fragment>
}